export default function StringMap() {
    const name = "stringmap";
    const fields = {
        "attributevalue":"attributevalue",
        "attributename":"attributename",
        "objecttypecode":"objecttypecode",
        "langid":"langid",
        "value":"value",
    };
    const caseorigincode = {
        PHONE:"1",
        EMAIL:"2",
        WEB:"3",
        FACEBOOK:"2483",
        TWITTER:"3986",
    }
    const casetypecode = {
        QUESTION:"1",
        PROBLEM:"2",
        REQUEST:"3",
    }
    return{name, fields, caseorigincode}
}